import { useRef, useState } from 'react';
import { Offer, OfferBlock } from '../../models/shared/Offer';
import BlockToolbar from './BlockToolbar';
import LineItemsEditor, { LineItemsEditorHandle } from '../LineItemsEditor';
import { AdvancedButton } from '../AdvancedButton';
import { useText } from '../../context/TextContext';

interface Props {
    block: OfferBlock;
    offer: Offer;
    readOnly?: boolean;
    onBlockUpdate: (updatedBlock: OfferBlock) => void;
    onOfferUpdate: (update: Partial<Offer>) => void;
    onBlockDelete: () => void;
    onMoveUp?: () => void;
    onMoveDown?: () => void;
}

export default function BlockLineItems(props: Props) {
    const { offer, onOfferUpdate, readOnly } = props;
    const [showToolbar, setShowToolbar] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const lineItemsEditorRef = useRef<LineItemsEditorHandle>(null);
    const text = useText();

    return (
        <div
            ref={containerRef}
            className="position-relative w-100"
            onClick={() => !readOnly && setShowToolbar(true)}
        >
            <BlockToolbar
                contentRef={containerRef}
                onDelete={props.onBlockDelete}
                onMoveDown={props.onMoveDown}
                onMoveUp={props.onMoveUp}
                showToolbar={showToolbar}
                setShowToolbar={setShowToolbar}
                readOnly={props.readOnly}
            >
                <AdvancedButton
                    variant="clear"
                    size="sm"
                    onClick={() => lineItemsEditorRef.current?.addLineItem()}
                    icon='bi-plus'
                >
                    {text.addRow}
                </AdvancedButton>
                <AdvancedButton
                    variant="clear"
                    size="sm"
                    onClick={() => lineItemsEditorRef.current?.addDiscountItem()}
                    icon='bi-plus'
                >
                    {text.addDiscount}
                </AdvancedButton>
            </BlockToolbar>

            <LineItemsEditor
                ref={lineItemsEditorRef}
                lineItems={offer.lineItems || []}
                onLineItemsChange={(lineItems) => onOfferUpdate({ lineItems })}
                readOnly={readOnly}
            />
        </div>
    );
}
